<template>
    <div class="py-2 px-2" id="Dashboard__Header">
        <div class="row g-0">
            <div class="col-md-4 col-12 fw-bold">
                <p class="m-0">
                    {{ formatingDateOrTime(today, dateFormat) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./CentralDashboardHeader"></script>
